// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation, no-console */

const rateLimitKey = 'login-rate-limit-end-time';

export const setRateLimitEndTime = (value: number) => {
  try {
    window.localStorage.setItem(rateLimitKey, value);
  } catch (e) {
    console.log(e);
  }
};

export const getRateLimitEndTime = (): number | null => {
  try {
    return parseInt(window.localStorage.getItem(rateLimitKey), 10);
  } catch (e) {
    console.log(e);
  }

  return null;
};
